const ptCreateFile: Record<string, { message: string; description: string }> = {
  "ledgerEditor.nameYourFile": {
    message: "Nomeie seu arquivo...",
    description: "Placeholder for file name input",
  },
};

export default ptCreateFile;
